var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZarinpalSingleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8928 5.5772C15.1376 4.96975 15.7301 4.57143 16.389 4.57143H26.7299C27.8699 4.57143 28.6494 5.71467 28.226 6.76565L20.3072 26.4228C20.0625 27.0302 19.4699 27.4286 18.811 27.4286H8.47013C7.33013 27.4286 6.5506 26.2853 6.97399 25.2343L14.8928 5.5772Z",
    fill: "url(#paint0_linear_11611_33178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5143 18.2857C14.3014 18.2857 17.3714 15.2157 17.3714 11.4286C17.3714 7.64147 14.3014 4.57143 10.5143 4.57143C6.72718 4.57143 3.65714 7.64147 3.65714 11.4286C3.65714 15.2157 6.72718 18.2857 10.5143 18.2857Z",
    fill: "#0A33FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3714 11.4286C17.3714 15.2157 14.3014 18.2857 10.5143 18.2857C10.2691 18.2857 10.027 18.2729 9.78851 18.2478L14.7182 6.0108C16.3326 7.26535 17.3714 9.22565 17.3714 11.4286Z",
    fill: "url(#paint1_linear_11611_33178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11611_33178",
    x1: 21.8596,
    y1: 4.57143,
    x2: 13.7789,
    y2: 27.4564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD60A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BA09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11611_33178",
    x1: 14.6682,
    y1: 6.01925,
    x2: 9.77072,
    y2: 18.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A33FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZarinpalSingleLogo);
export default __webpack_public_path__ + "static/media/zarinpalSingleLogo.4047c4634a595ebc2a63e1446c3b42d7.svg";
export { ForwardRef as ReactComponent };